import { Component, AfterViewInit, ViewChild, LOCALE_ID, Injectable, Injector } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { verifyMyKadNo } from '../directives/myKadNo-validation.directive';
import { requireMyKadNo } from '../directives/myKadNo-required.directive';
import { optionalField } from '../directives/optional-field.directive';
import { AppService } from '../app.service';
import { User } from '../model/user.model';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http'; 
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
  
@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})

export class FormComponent implements AfterViewInit {

	user: User[];
	person=new User();
	loading: boolean;
	errorMessage: string;
	gcaptchaResponse: string;
	errResponse: string;
	errCode: string;
	closeModal: string;
	modalReference: NgbModalRef;
	occupationList: any;
	checkTimeURL: string;
	weekdaysTimeFrom: string = "";
	weekdaysTimeTo: string = "";
	weekendTimeFrom: string = "";
	weekendTimeTo: string = "";
	perakuanChecked = false;
	submitted = false;
		
	onlineForm = this.fb.group({
		myKadNo: this.fb.group({
				first: ['', [Validators.required]],
				middle: ['', [Validators.required]],
				end: ['', [Validators.required]]
			}),
		businessTypeCode: ['', {
			validators: [Validators.required]
		}],
		remarks: [''],
		perakuanCheckbox: new FormControl('', [Validators.required]), // use only for FE validation
		recaptchaReactive: new FormControl('', [Validators.required]) // use only for FE validation
	}, {validator: [requireMyKadNo('myKadNo'), verifyMyKadNo('myKadNo'), optionalField('remarks')]});	

	constructor( private fb: FormBuilder, private appService:AppService, private modalService: NgbModal, private http: HttpClient, private translateService: TranslateService ) {
		appService.getJSON().subscribe(data => {
			this.occupationList = data.occupationList;
			this.checkTimeURL = data.maintenanceURL;

			this.translateService.use(localStorage.getItem('locale'));
			
			this.getMaintenanceTime().subscribe(data => {
				if(data.ok) {
					this.onLoad(data.body.startTime, data.body.endTime);
					this.weekdaysTimeFrom = data.body.weekdayStartTime;
					this.weekdaysTimeTo = data.body.weekdayEndTime;
					this.weekendTimeFrom = data.body.weekendStartTime;
					this.weekendTimeTo = data.body.weekendEndTime;
				}							
			}, err => {
				console.log("Error: ", err.message)
			});
		});		
	}

	public getMaintenanceTime(): Observable<any> {
		let ok: string;
		const headers = { 
			'content-type': 'application/json'
		}
		const body= {};

		return this.http.post(this.checkTimeURL, body, {'headers': headers, observe: 'response', 'responseType': 'json'})
	}

	getTranslatedItems(key: string): any {
		return this.translateService.instant(key);
	}

	convertTime12to24 = (time12h) => {
		const [time, modifier] = time12h.split(' ');
		let [hours, minutes] = time.split(':');
	  
		if (hours === '12') {
		  hours = '00';
		}
	  
		if (modifier === 'PM') {
		  hours = parseInt(hours, 10) + 12;
		}
	  
		return `${hours}:${minutes}`;
	}

	disableButton() {
		$('#btn-reset').prop("disabled", true);
		$('#btn-submit').addClass("disabled");
	}

	enableButton() {
		$('#btn-reset').prop("disabled", false);
		$('#btn-submit').removeClass("disabled");
	}

	onLoad(startTime, endTime) {	
		var date = new Date();
		var hours = date.getHours();
		var minutes = date.getMinutes();
		var start = this.convertTime12to24(startTime).split(":");
		var end = this.convertTime12to24(endTime).split(":");

		if ((parseInt(start[0]) < hours || parseInt(start[0]) == hours && parseInt(start[1]) <= minutes) && (hours < parseInt(end[0]) || hours == parseInt(end[0]) && minutes <= parseInt(end[1]))) {	
			this.onlineForm.enable();
			this.enableButton();				
		} else {
			this.onlineForm.disable();
			this.disableButton();
		}
		
	}

  	checkSubmit = false;
	onSubmit(formDir, popup)
	 {
		this.checkSubmit = true;
		if (this.onlineForm.errors == null) {
			this.submitted = true;
			if (this.onlineForm.valid) {
				var isCaptchaValidated = false;
				if (this.gcaptchaResponse.length == 0) {
					isCaptchaValidated = false;
				} else {
					isCaptchaValidated = true;
				}

				if (isCaptchaValidated) {
					if (this.onlineForm.value.perakuanCheckbox == true) {
						this.addMember(formDir, popup);	
					} else {
						this.onlineForm.value.perakuanCheckbox = false;
						this.onlineForm.setErrors({'perakuanCheckbox': true});

						return false;
					}
				}	
			} 
		}
	}

	get data(): string {
		return this.appService.sharedData;
	}

	resetForm() {
		this.submitted = false;

		Object.keys(this.onlineForm.controls).forEach((key) => {
			const control = this.onlineForm.controls[key];
			control.markAsPristine();
			control.markAsUntouched();
			control.clearValidators();
			control.updateValueAndValidity();
			control.setErrors(null);
		});

		this.onlineForm = this.fb.group({
			myKadNo: this.fb.group({
					first: ['', [Validators.required]],
					middle: ['', [Validators.required]],
					end: ['', [Validators.required]]
				}),
			businessTypeCode: ['', {
				validators: [Validators.required]
			}],
			remarks: [''],
			perakuanCheckbox: new FormControl('', [Validators.required]), // use only for FE validation
			recaptchaReactive: new FormControl('', [Validators.required]) // use only for FE validation
		}, {validator: [requireMyKadNo('myKadNo'), verifyMyKadNo('myKadNo'), optionalField('remarks')]});
	
		$("#remarks").addClass("hide");
	}

	refreshForm() {
		this.resetForm();
		$('#topAlert').addClass('hide');
	}

	ngAfterViewInit() {
		this.errResponse = this.appService.sharedData;
	}

	showErrorMsg(): string {
		this.ngAfterViewInit();

		if(this.errResponse !== undefined) {
			if(this.errResponse.includes("-")) {			
				var errResp = this.errResponse.split("-");
				this.errCode = errResp[1];
				return errResp[0];
			} else {
				this.errCode = this.errResponse;
				return this.errResponse;
			}
		}
	}

	showErrorCode(): string {
		return this.errCode;
	}

	changeField(e) {
		this.onlineForm.get('businessTypeCode').setValue(e.target.value, {
		   onlySelf: true
		})

		if(e.target.value == 'S990') {
			$("#remarks").removeClass("hide");
		} else {
			$("#remarks").addClass("hide");
		}
	}

	showLoading() {
		$("form").addClass("loading");
	}
	
	hideLoading() {
		$("form").removeClass("loading");
	}

	resolved(captchaResponse: string) {
		this.gcaptchaResponse = captchaResponse;
	}
 
	addMember(formDir, popup) {
		$('#topAlert').addClass('hide');
		this.loading = true;
		this.showLoading();
    	this.errorMessage = "";
		delete this.onlineForm.value.perakuanCheckbox; 
		delete this.onlineForm.value.recaptchaReactive; 
		
		this.appService.addMember(formDir, this.onlineForm, this.onlineForm.value, this.gcaptchaResponse, popup)
		.subscribe(data => {
			this.user=data;			
			this.hideLoading();
			this.resetForm();	
		},
        (error) => { 
            //Error callback
			$('#topAlert').removeClass('hide');
			this.hideLoading();
			this.errResponse  = "REG000";
			this.onlineForm.setErrors({'ErrorResponse': true});
			window.scrollTo(500, 0);
			grecaptcha.reset();
			this.loading = false;
			this.resetForm();
          //throw error;
        })
	}
	
}



